/**
 * Converte qualquer representação de timestamp Firestore/string/Date para milissegundos.
 * Usado para ordenar livros por finishedAt / updatedAt.
 */
export function toMs(ts: unknown): number {
  if (!ts) return 0;
  if (typeof (ts as { toDate?: () => Date }).toDate === "function") {
    return (ts as { toDate: () => Date }).toDate().getTime();
  }
  const d = new Date(ts as string);
  return isNaN(d.getTime()) ? 0 : d.getTime();
}
